<template>
      <v-row
        align="center"
        justify="center"
      >
        
         <v-col
         v-if="error != ''"
          cols="12"
          sm="8"
          md="4"
        >
            <p class="text-center">{{this.error}}</p>
            <p class="text-center"><v-btn elevation="0" width="150" to="/login" color="primary" large class="text-body-1">Go to Log In</v-btn></p>
         </v-col>
         <v-col
         v-if="showResetPasswordForm && error == ''"
          cols="12"
          sm="8"
          md="4"
        >
          <v-card v-if="!passwordResetSuccessfully"  class="elevation-12" :loading="loading">
            <v-toolbar
              flat
            >
              <v-toolbar-title>Reset Password</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            
            <v-form
              ref="form"
              v-model="valid"
              @submit.prevent="handleResePasswordClick"
            >
              <v-card-text class="pb-0">
                <v-alert
                    text
                    prominent
                    color="primary"
                    icon="priority_high"
                    v-if="resetPasswordServerError!=''"
                >
                  <v-row align="center">
                    <v-col class="grow">{{resetPasswordServerError}}</v-col>
                  </v-row>
                </v-alert>
                <v-text-field
                    id="password"
                    label="New Password"
                    name="password"
                    outlined
                    v-model="password"
                    dense
                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show1 ? 'text' : 'password'"
                    hint="At least 8 characters"
                    counter
                    @click:append="show1 = !show1"
                    :validate-on-blur="isFirstSubmissionAttempt"
                    :rules="passwordRules"
                  ></v-text-field>
                  <v-text-field
                    id="confirmPassword"
                    label="Confirm Password"
                    name="confirmPassword"
                    outlined
                    v-model="confirmPassword"
                    dense
                    :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show2 ? 'text' : 'password'"
                    counter
                    @click:append="show2 = !show2"
                    :rules="[() => password == confirmPassword || 'The passwords don\'t match', v => !!v || 'Please retype your password']"
                  ></v-text-field>
              </v-card-text>
              <v-card-actions class="px-4 pb-3 pt-5">                
                <v-btn elevation="0" block type="submit" color="primary" large class="text-body-1">Reset Password</v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
          <v-card v-else  class="elevation-12">
              <v-card-text class="pb-5">
                <lottie-animation :loop="false" style="width: 8em;" path="green-tick.json" />
                <div class="text-center text-h6 text--primary text-weight-medium" >Password Changed!</div>
                <div class="text-center" >Your password has been reset successfully.</div>
                <v-btn elevation="0" block @click="openApp" color="primary" large class="text-body-1 my-5">Go to the App</v-btn>
                <v-btn elevation="0" block @click="openBusinessPortal" color="primary" large class="text-body-1">Go to the Business Portal</v-btn>
              </v-card-text>
          </v-card>
        </v-col>
        <v-col
          cols="12"
          sm="8"
          md="4"
          v-if="(!showResetPasswordForm) && error == ''"
        >
          <v-card flat color="transparent">
            <v-card-text class="pb-0">
                <p class="text-center"><img src="../assets/logo-large.png" /></p>
                <v-row align="center" justify="center">
                    <v-col cols="10">
                        <p class="text-center">
                            <v-progress-linear
                                indeterminate
                                color="primary"
                                height="5"
                                class="mt-5"
                                rounded
                            ></v-progress-linear>
                        </p>
                    </v-col>
                </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
</template>
<script>

import { getAuth } from '@/shared/firebase_utils';
import {verifyPasswordResetCode, confirmPasswordReset, applyActionCode} from 'firebase/auth';
import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue";

export default {
    name: 'EmailHandler',
    components: {
    LottieAnimation,
  },
    created() {
        this.mode = this.$route.query.mode;
        this.actionCode = this.$route.query.oobCode;
        this.continueUrl = this.$route.query.continueUrl;
        this.lang = 'en';
        switch (this.mode) {
                case 'resetPassword':
                // Display reset password handler and UI.
                this.handleResetPassword();
                break;
                case 'recoverEmail':
                // Display email recovery handler and UI.
                this.handleRecoverEmail();
                break;
                case 'verifyEmail':
                // Display email verification handler and UI.
                this.handleVerifyEmail();
                break;
                default:
                this.error = 'This link is either invalid or expired';
        }
    },
    data() {
        return {
            accountEmail: '',
            valid: false,
            auth: getAuth(),
            mode:'',
            actionCode: '',
            continueUrl: '',
            lang: '',
            message: '',
            showResetPasswordForm: false,
            passwordResetSuccessfully: false,
            password: '',
            confirmPassword: '',
            show1: false,
            show2: false,
            isFirstSubmissionAttempt: true,
            passwordRules: [
                v => !!v || 'Please enter your password',
                v => v.length >= 8 || 'The password must be at least 8 characters long',
            ],
            loading: false,
            error: '',
            resetPasswordServerError: '',
        };
    },
    methods: {
        handleResetPassword() {
            // Verify the password reset code is valid.
            verifyPasswordResetCode(this.auth, this.actionCode).then((email) => {
                this.accountEmail = email;
                //Show the reset screen with the user's email and ask the user for the new password.
                this.showResetPasswordForm = true;
            }).catch((error) => {
                // Invalid or expired action code. Ask user to try to reset the password
                // again.
                console.log('Error from the handleResetPassword method: ' + error);
                this.error = 'This link is either invalid or expired';
            });
        },
        openApp() {
          window.location = 'https://pappyon.page.link/app';

        },
        openBusinessPortal() {
          window.location = 'https://business.pappyon.com/';

        },
        handleResePasswordClick() {
             this.resetPasswordServerError = '';
            if (this.$refs.form.validate()) {
                this.loading = true;
                // Save the new password.

                confirmPasswordReset(this.auth, this.actionCode, this.password).then(async (resp) => {
                // Password reset has been confirmed and new password updated.
                // TODO: Display a link back to the app, or sign-in the user directly
                // if the page belongs to the same domain as the app:
                
                // await this.auth.signInWithEmailAndPassword(this.accountEmail, this.password);
                
                this.error = "";
                this.passwordResetSuccessfully = true;
                // this.$router.push({ name: 'Dashboard' });
                // window.location = process.env.NODE_ENV == 'production'? 'https://pappyon.page.link/passwordResetSuccessfully' : 'https://pappyonstaging.page.link/passwordResetSuccessfully';

                // TODO: If a continue URL is available, display a button which on
                // click redirects the user back to the app via continueUrl with
                // additional state determined from that URL's parameters.
                }).catch((error) => {
                  // Error occurred during confirmation. The code might have expired or the
                  // password is too weak.
                  this.loading = false;
                  this.resetPasswordServerError = error.message || error;
                });
            }
        },
        handleRecoverEmail() {},
        handleVerifyEmail() {
          applyActionCode(this.auth, this.actionCode).then(async (resp) => {
            // Email address has been verified.
            var user = this.auth.currentUser;
            if (user) {
                console.log('user exists');
                // User is signed in.
                await user.reload();
                this.$router.push({ name: 'Dashboard', query: { emailVerfied: true} });
            } else {
                console.log('user does not exist');
                // No user is signed in.
                this.$router.push({ name: 'Login', query: { emailVerfied: true} });
            }
            // TODO: Display a confirmation message to the user.
            // You could also provide the user with a link back to the app.

            // TODO: If a continue URL is available, display a button which on
            // click redirects the user back to the app via continueUrl with
            // additional state determined from that URL's parameters.
        }).catch((error) => { 
            // Code is invalid or expired. Ask the user to verify their email address
            // again.
            this.error = 'This link is either invalid or expired';
        });
      },
    }
}
</script>